import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from 'next/app';
import Head from 'next/head';
import Router from 'next/router';
import * as NProgress from 'nprogress';
import { GoogleAnalytics } from '@next/third-parties/google';

import Notifier from '../components/common/Notifier';

import React from 'react';

import { themeDark, themeLight } from '../lib/theme';

import '../styles/global.css';

Router.events.on('routeChangeStart', () => {
  NProgress.start();
});

Router.events.on('routeChangeComplete', () => {
  function prepareUrl(params) {
    const url = new URL(location.href);
    const queryParams = new URLSearchParams(location.search);
    let customUrl = url.protocol + '//' + url.hostname + url.pathname;
    for (const paramName of params) {
      const paramValue = queryParams.get(paramName);
      if (paramValue) {
        customUrl = customUrl + '/' + paramName + '/' + paramValue;
      }
    }

    if (customUrl.includes('.com//')) {
      customUrl = customUrl.replace('.com//', '.com/');
    }
    // console.log(customUrl);
    return customUrl;
  }

  (window as any).plausible('pageview', {
    u: prepareUrl(['category', 'company', 'state', 'page', 'r']),
  });

  NProgress.done();
});

Router.events.on('routeChangeError', () => NProgress.done());

class MyApp extends App {
  public static async getInitialProps({ Component, ctx }) {
    // console.log('MyApp.getInitialProps');

    const pageProps = {
      isServer: !!ctx.req,
      pathname: ctx.pathname,
    };

    if (Component.getInitialProps) {
      Object.assign(pageProps, await Component.getInitialProps(ctx));
    }

    const appProps = { pageProps };

    return {
      ...appProps,
    };
  }

  public async componentDidMount() {
    function prepareUrl(params) {
      const url = new URL(location.href);
      const queryParams = new URLSearchParams(location.search);
      let customUrl = url.protocol + '//' + url.hostname + url.pathname;
      for (const paramName of params) {
        const paramValue = queryParams.get(paramName);
        if (paramValue) {
          customUrl = customUrl + '/' + paramName + '/' + paramValue;
        }
      }

      if (customUrl.includes('.com//')) {
        customUrl = customUrl.replace('.com//', '.com/');
      }
      // console.log(customUrl);
      return customUrl;
    }

    (window as any).plausible('pageview', {
      u: prepareUrl(['category', 'company', 'state', 'page', 'r']),
    });
  }

  public render() {
    const { Component, pageProps } = this.props;

    const isThemeDark = false;
    // get isThemeDark from localStorage

    // const isServer = typeof window === 'undefined';
    const googleTagId = process.env.NEXT_PUBLIC_GOOGLE_TAG_ID;
    const googleAdsConversionLabel = process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL;

    return (
      <CacheProvider value={createCache({ key: 'css' })}>
        <ThemeProvider theme={isThemeDark ? themeDark : themeLight}>
          <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            {/* <script
              defer
              data-domain="workinbiotech.com"
              src="https://plausible.io/js/plausible.manual.js"
            /> */}
            <script defer data-api="/api/event" data-domain="workinbiotech.com" src="/js/script.js" />

            <script
              dangerouslySetInnerHTML={{
                __html:
                  'window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }',
              }}
            />

            {googleTagId ? (
              <script
                dangerouslySetInnerHTML={{
                  __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('set', 'linker', { domains: [], decorate_forms: false });
                    gtag('set', { conversion_linker: false });${
                      googleAdsConversionLabel
                        ? `
                    gtag('event', 'conversion', {
                      send_to: '${googleTagId}/${googleAdsConversionLabel}',
                      value: 1.0,
                      currency: 'USD'
                    });`
                        : ''
                    }`,
                }}
              />
            ) : null}
          </Head>
          <CssBaseline />
          <Component {...pageProps} currentRoute={pageProps.pathname} isThemeDark={isThemeDark} />
          <Notifier />
          {googleTagId ? <GoogleAnalytics gaId={googleTagId} /> : null}
        </ThemeProvider>
      </CacheProvider>
    );
  }
}

export default MyApp;
